export default __webpack_public_path__ + "static/media/English_CA_Sample.13847213.png";